export default __webpack_public_path__ + "static/media/left-arrow.8727440d.svg";